import { render } from "./toggle.vue?vue&type=template&id=ff6c3840&lang=pug"
import script from "./toggle.vue?vue&type=script&lang=js"
export * from "./toggle.vue?vue&type=script&lang=js"

import "./toggle.vue?vue&type=style&index=0&id=ff6c3840&lang=less"

import exportComponent from "/home/runner/work/argos-control-web/argos-control-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QToggle});
